export const ROUTES = {
    LOGIN: '/login',
    YOUR_CHECKS: '/',
    SETTINGS: '/settings',
    CREATE_CHECK: '/create-check',
    QR_SCANNER: '/qr-scanner',
    ACTIVATE: '/activate'
};
